import { render, staticRenderFns } from "./workday.vue?vue&type=template&id=50cdde94&"
import script from "./workday.vue?vue&type=script&lang=js&"
export * from "./workday.vue?vue&type=script&lang=js&"
import style0 from "./workday.vue?vue&type=style&index=0&id=50cdde94&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports